import { takeLatest, all } from 'redux-saga/effects';
import apiSaga from 'legacy/src/shared/util/apiSagaGenerator';

import { fetchTags } from './actions';

export function* fetchTagsSaga({ payload }) {
  const { subjectId, itemId, questionDetailsToogleRationale, educationPeriod } =
    payload;
  let args = '';
  args += `${!!args ? `${args} + '&'` : '?'}${
    !!educationPeriod ? `education_period=${educationPeriod}` : ''
  }`;
  yield apiSaga(fetchTags, {
    url: `tagging/api/subject/${subjectId}/items/${itemId}/${args}`,
    callback: questionDetailsToogleRationale,
    callbackValue: true,
  });
}

export default function* itemTagsSaga() {
  yield all([takeLatest(fetchTags.TRIGGER, fetchTagsSaga)]);
}
